import taskManagerApi from "@/features/shared/services/taskManagerApi";
const buildTrashParams = (page, filters, limit) => ({
    page,
    include_custom_fields: true,
    ...(limit ? { limit } : {}),
    ...(filters?.search ? { search: filters.search } : {}),
    ...(filters?.status ? { status: filters.status } : {}),
    ...(filters?.priority ? { priority: filters.priority } : {}),
    ...(filters?.city ? { city: filters.city } : {}),
    ...(filters?.client ? { client: filters.client } : {}),
    ...(filters?.project ? { project: filters.project } : {}),
});
const extractErrorMessage = (error, fallback) => {
    if (typeof error === "object" && error !== null) {
        const maybeError = error;
        const serverError = maybeError.response?.data?.error;
        if (serverError?.details) {
            return serverError.details;
        }
        if (serverError?.message) {
            return serverError.message;
        }
        if (maybeError.response?.data?.message) {
            return maybeError.response.data.message;
        }
    }
    if (error instanceof Error && error.message) {
        return error.message;
    }
    return fallback;
};
export const getDeletedTasks = async (page, filters, limit) => {
    try {
        const response = await taskManagerApi.get("/task/trash", {
            params: buildTrashParams(page, filters, limit),
        });
        return response.data?.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error, "Impossible de charger la corbeille."));
    }
};
export const restoreDeletedTask = async (taskId) => {
    try {
        await taskManagerApi.post(`/task/trash/${taskId}/restore`);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error, "Impossible de restaurer la tâche."));
    }
};
export const deleteTaskPermanently = async (taskId) => {
    try {
        await taskManagerApi.delete(`/task/trash/${taskId}`);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error, "Impossible de supprimer définitivement la tâche."));
    }
};
export const bulkDeleteTasksPermanently = async (taskIds) => {
    try {
        await taskManagerApi.delete("/task/trash", {
            data: { ids: taskIds },
        });
    }
    catch (error) {
        throw new Error(extractErrorMessage(error, "Impossible de supprimer définitivement les tâches sélectionnées."));
    }
};
